<template>
  <div class="home">
    <div id="drag">
      <div class="Yuan" @click="testShowBtn">
        <span></span>
        <span></span>
      </div>
      <div class="Yuan-title">
        <div
          style="height: 20px; width: 100%; cursor: all-scroll"
          class="YuanTitleDrag"
        ></div>
        <div class="zTreeDiv">
          <ul id="discussTheTopicTree" class="ztree"></ul>
        </div>
      </div>
    </div>

    <div id="MyViewerDiv"></div>

    <canvas id="snapshot" style="display: none"></canvas>

    <div id="lll">
      <div
        id="div_viewpoint"
        class="m-right-sidebar"
        style="
          position: absolute;
          display: none;
          top: 20px;
          right: 30px;
          transition: none;
        "
      >
        <h2 style="font-size: 20px; font-weight: 300; cursor: all-scroll">
          视点保存
        </h2>
        <div
          class="btnClose close_bt_p"
          onclick="bimViewPointNew.hiddenViewPoint();"
          style="color: #000000; font-weight: 300"
        >
          ×
        </div>
        <!-- <hr class="v-spacer-large"> -->
        <div class="navBox">
          <!-- <ul id="nav" class="nav" name="nav" style="display: block;">
            <li>
              <b style="border-radius: 15px 0 0 15px;">基本</b>
            </li>
            <li>
              <b>碰撞</b>
            </li>
            <li>
              <b>协作</b>
            </li>
          </ul>-->
          <div id="search_viewpoint" class="search">
            <b class="imgsearch"></b>
            <button
              id="vp-imgsearch"
              style="position: absolute; left: 0"
              class="btnSearch"
              onclick="bimViewPointNew.filterNodes()"
            >
              <img
                width="20px"
                style="position: relative; left: 4px"
                src="../../../assets/img/搜索 (2).png"
              />
            </button>
            <input
              type="text"
              id="vp-searchtxt"
              value="请输入搜索内容..."
              onfocus="if(value=='请输入搜索内容...')  {value=''}"
              onblur="if (value=='') {value='请输入搜索内容...'}"
              onkeypress="bimViewPointNew.viewpoint_keydown(event)"
              name="name"
              style="padding-left: 20px"
            />
            <b
              class="clo1"
              id="vp-close"
              style="
                font-weight: 300;
                position: absolute;
                right: 0;
                color: #c3c3c3;
                font-size: 16px;
              "
              onclick="bimViewPointNew.closeShow()"
              >×</b
            >
          </div>
        </div>
        <div class="body_viewpoint">
          <ul id="treeDemo_viewpoint" class="treeDemo_viewpoint ztree"></ul>
        </div>
        <!-- <hr class="v-spacer-large"> -->
        <button
          class="btn btn-info viewpoint_btn btn_fas"
          style="display: none"
          id="vp-btn-deletebatch"
          data-placement="bottom"
          data-toggle="tooltip"
          title="删除"
          onclick="bimViewPointNew.deleteViewPoints()"
        >
          删除
        </button>
        <el-button
          type="primary"
          id="vp-btn-mark"
          data-placement="bottom"
          data-toggle="tooltip"
          title="涂鸦"
          size="small"
          style="margin: 0 0 0 66px; display: inline-block"
          onclick="bimViewPointNew.showMarkTool()"
          >涂鸦</el-button
        >
        <el-button
          type="primary"
          id="vp-btn-save"
          data-placement="bottom"
          data-toggle="tooltip"
          size="small"
          title="保存"
          onclick="bimViewPointNew.onSaveLayer()"
          style="display: inline-block"
          >保存</el-button
        >
        <button
          size="small"
          type="primary"
          class="btn btn-info"
          id="vp-btn-share"
          title="分享"
          style="display: none"
          data-placement="bottom"
          data-toggle="tooltip"
          onclick="shareStructureQR.viewpointQr()"
        >
          分享
        </button>
        <button
          class="btn btn-info viewpoint_btn btn_fastn"
          style="display: none"
          id="vp-btn-startclash"
          data-placement="bottom"
          data-toggle="tooltip"
          title="发起碰撞"
          onclick="workflowCollision.main('','','-1')"
        >
          发起碰撞
        </button>
        <div
          id="rMenu_viewpoint"
          class="rMenu"
          style="top: 123px; visibility: hidden"
        >
          <ul id="rShowMenu_viewpoint">
            <li
              id="vp_m_add"
              onclick="bimViewPointNew.addTreeNode()"
              style="display: list-item"
            >
              新建视点目录
            </li>
            <li
              id="vp_m_del"
              onclick="bimViewPointNew.removeTreeNode()"
              style="display: list-item"
            >
              删除
            </li>
            <li
              id="vp_m_ren"
              onclick="bimViewPointNew.renameTreeNode()"
              style="display: list-item"
            >
              重命名
            </li>
            <!-- <li
              id="vp_m_faq"
              onclick="bimViewPointNew.createFlow()"
              style="display: list-item;"
            >发起流程</li>-->
            <!-- @*
            <li
              id="vp_m_updateMark"
              onclick="bimViewPointNew.updateMark()"
              style="display: none;"
            >更新涂鸦</li>*@-->
          </ul>
        </div>
      </div>
    </div>
    <div id="box_gray" class="gray"></div>
    <!-- @*过滤器*@ -->
    <div class="filter_box" id="gg" style="cursor: default; display: none">
      <div class="box_title">过滤器</div>
      <div class="btnClose" onclick="bimOriginFilter.hideDoc()">×</div>

      <div class="box_content">
        <div class="tab_title">
          <ul id="tabs" class="clearfix">
            <li class="current" onclick="boxselect(this)">
              <a href="#" title="过滤器">过滤器</a>
            </li>
            <li onclick="boxselect(this)">
              <a href="#" title="框选集">框选集</a>
            </li>
          </ul>
        </div>
        <!-- <ul id="treeDemo" class="ztree content_particulars"></ul> -->
        <div class id="menu_content_box">
          <div id="tab1" class="menu_table" style="display: block">
            <div class="farther" id="list">
              <div class="body_origin_filter">
                <ul id="treeDemo_origin_filter" class="ztree scroll_bar"></ul>
              </div>
              <div
                id="rMenu_origin_filter"
                class="rMenu"
                style="top: 253px; left: 257px; visibility: hidden"
              >
                <ul id="rShowMenu_origin_filter">
                  <li
                    id="origin_f_add"
                    onclick="bimOriginFilter.xx()"
                    style="display: none"
                  >
                    增加
                  </li>
                  <li
                    id="origin_f_del"
                    onclick="bimOriginFilter.yy()"
                    style="display: none"
                  >
                    删除
                  </li>
                  <li
                    id="origin_f_ren"
                    onclick="bimOriginFilter.zz()"
                    style="display: none"
                  >
                    重命名
                  </li>
                </ul>
              </div>
            </div>
            <div class="footr_box">
              <div class="box_options" style="display: none">
                <div class="clearfix">
                  <input
                    class="fl"
                    type="button"
                    onclick="bimOriginFilter.contreChoose()"
                    value="反选"
                  />
                  <input
                    class="fl daochu"
                    type="button"
                    onclick="filterExecute.modelshowEXCELvalue()"
                    id="daochu_btn"
                    value="导出工程量"
                    style="display: none"
                  />
                  <input
                    class="fr top_img"
                    type="button"
                    id="advanced_btn"
                    value="高级选项"
                  />
                </div>
                <div class="sidebar_advanced" style="display: none">
                  <div class="screen_box">
                    <p>
                      <span>参数:</span>
                      <select id="canshu" class="select"></select>
                    </p>
                    <p>
                      <span>条件:</span>
                      <select id="tiaojian" class="select">
                        <option value>请选择筛选条件</option>
                      </select>
                    </p>
                    <p>
                      <span>值:</span>
                      <input value id="chooseValue" />
                    </p>
                  </div>
                </div>
              </div>

              <div class="box_btn_op">
                <div class="clearfix">
                  <!-- @*
                    <input
                      class="fl"
                      type="button"
                      value="确定"
                      onclick="filterExecute.attribute_select()"
                  />*@-->
                  <input
                    class="fr ml_20"
                    type="button"
                    onclick="bimOriginFilter.attribute_save()"
                    value="收藏"
                  />
                </div>
              </div>
            </div>
          </div>
          <div id="tab2" class="menu_table" style="display: none">
            <div class="farther" id="list">
              <div class="body_originOther_filter">
                <ul
                  id="treeDemo_originOther_filter"
                  class="ztree scroll_bar"
                ></ul>
              </div>
              <div
                id="rMenu_originOther_filter"
                class="rMenu"
                style="visibility: hidden"
              >
                <ul id="rShowMenu_originOther_filter">
                  <li
                    id="originOther_f_addPlanDir"
                    onclick="bimOriginFilter.addPlanDir()"
                  >
                    新建目录
                  </li>
                  <li
                    id="originOther_f_delPlan"
                    onclick="bimOriginFilter.removePlan()"
                  >
                    删除
                  </li>
                  <li
                    id="originOther_f_renPlan"
                    onclick="bimOriginFilter.renamePlan()"
                  >
                    重命名
                  </li>
                  <!-- <li id="originOther_f_faq" onclick="bimOriginFilter.createFlow()">发起流程</li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--添加标签 -->
    <div class="AddLable">
      <input type="hidden" id="mobl10" />
      <input type="hidden" id="mobl11" />
      <input type="hidden" id="mobl12" />
      <div>
        <label class="labelName">名称：</label>
        <input id="lableName" type="text" />
      </div>
      <br />
      <div>
        <label class="labelName">地点：</label>
        <input id="lableAddr" type="text" />
      </div>
      <br />
      <div>
        <label class="labelName">拍摄时间：</label>
        <input id="lableTime" type="text" placeholder="yyyy-MM-dd" />
      </div>
      <br />
      <div>
        <label>类型：</label>
        <dl class="labelType">
          <!-- <dd>
            <input type="radio" name="lableType" checked value="1" />
            <label for="material">
              <img src="../../assets/img/bmmc.png" /> 材料
            </label>
          </dd>
          <dd>
            <input type="radio" name="lableType" value="2" />
            <label for="material">
              <img src="../../assets/img/bmmc.png" /> 材料
            </label>
          </dd>-->
        </dl>
      </div>
      <br />
      <div class="isQJ" style="display: none">
        <label class="labelName">是否全景图：</label>
        <input type="radio" name="isQJ" value="1" />是
        <input type="radio" name="isQJ" value="0" checked />否
      </div>
      <br />
      <div class="lableFile">
        <label>文件：</label>
        <button
          type="button"
          class="layui-btn layui-btn layui-btn-sm marginLeft10"
          id="lableFile"
        >
          选择文件
        </button>
      </div>
      <br />
      <div class="qjLink" style="display: none">
        <label class="labelName">全景链接：</label>
        <input id="qjLink" type="text" />
      </div>
      <br />
      <div class="form-group rt">
        <button id="lableSubmit"></button>
        <button
          type="button"
          class="layui-btn"
          onclick="EaBIM.lableSaveChange()"
        >
          提交
        </button>
        <!-- <button type="button" class="layui-btn" id="lableSubmit">提交</button> -->
      </div>
      <br />
    </div>
    <!-- 添加参数 -->
    <div class="AddProperty">
      <p>
        <button
          type="button"
          class="layui-btn layui-btn-normal layui-btn-sm marginLeft10"
          onclick="EaBIM.addPropertyGroup()"
        >
          添加分组
        </button>
        <br />
        <br />
      </p>
    </div>
    <el-card
      class="DIYProperty"
      :body-style="{ padding: '10px' }"
      shadow="hover"
      v-show="modelId != -1"
    >
      <el-row
        style="
          border-bottom: 1px solid #eee;
          height: 40px;
          line-height: 40px;
          margin-bottom: 10px;
        "
      >
        <el-col :span="10" :class="addClass" v-show="isShowaddClass">
          属性字段
        </el-col>
        <el-col :span="5" :class="addClass" v-show="isShowaddClass">
          <el-select v-model="searchType" size="small">
            <el-option key="2" label="交集" value="and"> </el-option>
            <el-option key="1" label="并集" value="or"> </el-option>
          </el-select>
        </el-col>
        <el-col :span="4" :offset="1" :class="addClass" v-show="isShowaddClass">
          <el-button size="mini" type="primary" @click="initPropertyList"
            >查询</el-button
          >
        </el-col>
        <el-col :span="4">
          <el-button
            size="mini"
            type="primary"
            :icon="iconClass"
            @click="isShow2"
          ></el-button>
        </el-col>
      </el-row>
      <el-row
        :class="addClass"
        v-show="isShowaddClass"
        v-for="(item, index) in propertyList"
        :key="index"
        style="height: 40px; line-height: 40px; margin: 3px"
      >
        <el-checkbox-group
          v-model="checkList"
          @change="
            data => {
              handleCheckedCitiesChange(data, item);
            }
          "
        >
          <el-col :span="7">
            <el-checkbox :label="item.name"></el-checkbox
          ></el-col>
          <el-col :span="13">
            <el-select
              v-model="item.searchValue"
              filterable
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item2 in item.val"
                :key="item2.value"
                :label="item2.value"
                :value="item2.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="3" :offset="1">
            <el-color-picker v-model="item.Color"></el-color-picker>
          </el-col>
        </el-checkbox-group>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import {
  GetWorkPlaneTree2,
  FindWorkPlaneModel,
  GetModelPropertyByModeId,
  FindModelProperty
} from "@/setAxios";
// import $ from "jquery";
export default {
  name: "propertyManagementModel",
  data() {
    return {
      isShowaddClass: true,
      iconClass: "el-icon-arrow-left",
      addClass: "animated fadeInLeft back",
      modelId: -1,
      options: {},
      checkList: [],
      propertyList: [],
      value: "",
      midList: [],
      searchType: "and"
    };
  },
  methods: {
    isShow2() {
      let _this = this;
      if (this.isShow == false) {
        this.isShow = true;
        this.isShowaddClass = true;
        this.addClass = "animated fadeInLeft back";
        this.iconClass = "el-icon-arrow-left";
      } else {
        this.addClass = "animated fadeOutLeft back";
        this.iconClass = "el-icon-arrow-right";
        this.isShow = false;
        setTimeout(function() {
          _this.isShowaddClass = false;
        }, 300);
      }
    },
    handleCheckedCitiesChange(data, item) {
      item.isSelect = !item.isSelect;
    },
    // 刷新数组
    initPropertyList() {
      let list = [];
      let plArr = this.propertyList.filter(ele => ele.isSelect);
      plArr.forEach(ele => {
        let searchWord = {
          name: "",
          value: ""
        };
        searchWord.name = ele.name;
        if (ele.searchValue) searchWord.value = ele.searchValue;
        list.push(searchWord);
      });
      if (!list.length) {
        EaBIM.restoreState();
        return;
      }
      FindModelProperty({
        mid: this.modelId,
        type: this.searchType,
        list
      }).then(res => {
        var arr = [];
        if (res.Data) {
          let arrayList = this.propertyList.filter(x => x.isSelect);
          res.Data.forEach(v => {
            arrayList.forEach(p => {
              let newlist = [];
              if (p.searchValue != undefined && p.searchValue != "") {
                newlist = v.list.filter(
                  x => x.name == p.name && x.value == p.searchValue
                );
              } else {
                newlist = v.list.filter(x => x.name == p.name);
              }
              if (newlist.length) {
                arr.push({ dbid: v.prop08, color: p.Color });
              }
            });
          });
        }
        EaBIM.selectChange(arr);
        this.$message({
          type: "success",
          message: "加载成功",
          duration: 1000
        });
      });
    },
    //初始化ztree
    init() {
      var _this = this;
      var setting = {
        view: {
          selectedMulti: false
        },
        check: {
          enable: false
        },
        data: {
          key: {
            name: "label"
          },
          simpleData: {
            enable: true,
            idKey: "ID",
            pIdKey: "ParentId"
          }
        },
        callback: {
          onClick: onclick
        }
      };
      var objs = $.fn.zTree.init(
        $("#discussTheTopicTree"),
        setting,
        this.options
      );
      if (objs != null) {
        $("#discussTheTopicTree_1_a").click();
      }
      function onclick(event, treeId, treeNode) {
        _this.showModel(treeNode.ID);
      }
    },
    testShowBtn() {
      if ($(".Yuan-title").css("display") != "none") {
        $(".Yuan-title").css("display", "none");
      } else {
        $(".Yuan-title").css("display", "block");
      }
    },
    viewers(data) {
      if (data.type == 1) {
        this.modelId = data.modelId;
        data.enterType = "sxgl";
        GetModelPropertyByModeId({ id: data.modelId }).then(res => {
          this.propertyList = res.Data;
          this.propertyList.forEach(ele => {
            ele.isSelect = false;
          });
        });
      } else {
        this.modelId = -1;
      }
      EaBIM.localServerModels(data);
    },
    getData() {
      let params = {
        xid: localStorage.getItem("xid"),
        pid: -1
      };
      GetWorkPlaneTree2(params).then(res => {
        this.options = res.Data;
        this.options.forEach(item => {
          this.judge(item);
        });
        this.init();
      });
    }, // 判断类型
    judge(item) {
      if (item.wopl07 == 1) {
        return (item.iconSkin = "pIcon01");
      } else if (item.wopl07 == 2) {
        return (item.iconSkin = "pIcon02");
      } else if (item.wopl07 == 3) {
        return (item.iconSkin = "pIcon03");
      } else {
        return (item.iconSkin = "pIcon04");
      }
    },
    showModel(value) {
      if (value.length) {
        value = value[0];
      }
      let params = {
        id: value
      };
      FindWorkPlaneModel(params).then(res => {
        if (res.Data == null) {
          this.$message({
            type: "warning",
            message: this.$t('工单任务.此节点未绑定模型或选择集')
          });
          return false;
        }
        let data = res.Data;
        this.viewers(data);
      });
    }
  },
  created() {
    this.flushSession();
    this.getData();
    window.discussTopic = this;
  },
  mounted() {
    //this.viewers();
    document.oncontextmenu = function() {
      return false;
    };
    Fcis.Fc(".Yuan", "#drag");
    Fcis.Fc(".lll", "#div_viewpoint");
    Fcis.Fc(".lll", "#gg");
  }
};
</script>

<style lang="less">
#drag {
  left: 90%;
  top: 15%;
}
/deep/ .view {
  padding: 0;
}
#MyViewerDiv {
  height: 100%;
  width: 100%;
  position: absolute;
  // float: left;
}
.home {
  // overflow: auto;
  // height: 100%;
  // position: relative;
}

.body_viewpoint .treeDemo_viewpoint {
  background: rgba(255, 255, 255, 0.8);
  width: 96%;
  height: 100%;
  border: none;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 15px;
}
.layer-background {
  background: rgba(255, 255, 255, 0.8) !important;
}
.DIYProperty {
  position: absolute;
  z-index: 10;
}
</style>
